<template>
	<div class="html5-container">
		<div class="" v-if="moduleList.length > 0" v-for="(item, index) in moduleList" :key="index">
			<div v-if="item.content != null">
				<!-- 图片 -->
				<div class="swipe-content" v-if="item.type == 1">
					<div class="" v-if="item.content.length > 0">
						<!-- 轮播 -->
						<van-swipe :autoplay="3000" indicator-color="white">
							<van-swipe-item v-for="(swipeItem, swipeIndex) in item.content" :key="swipeIndex" @click="clickToGo(swipeItem)">
								<img v-lazy="swipeItem.imgUrl" />
							</van-swipe-item>
						</van-swipe>
					</div>
					<div class="" v-else><img v-lazy="item.content.imgUrl" /></div>
				</div>

				<div v-if="item.type == 2">
					<!-- picLst -->
					<div class="subfield-content" v-if="typeof item.content.picLst == 'object' && item.content.picLst.length > 0">
						<div class="field-1">
							<div
								class="field-item"
								v-for="(contentItem, contentIndex) in item.content.picLst"
								:key="contentIndex"
								v-bind:class="'field-item-' + contentIndex"
								@click="clickToGo(contentItem)"
							>
								<img :src="contentItem.imgUrl" />
							</div>
						</div>
					</div>
					<!-- picLst -->
				</div>
			</div>
			<!-- 商品结果 -->

			<div class="style-list" v-if="item.type == 3 && item.goodsList.length > 0" v-bind:style="{ backgroundColor: item.bgColor }">
				<div class="can-wrap" :class="['style-list-' + item.rowCount, { 'can-wrap': item.showCount / item.rowCount > 1 }, { 'can-scroll': item.slide }]">
					<div class="style-item" :class="['style-' + item.style]" v-for="(gitem, gindex) in item.goodsList" :key="gindex" @click="clickToGoItems(gitem)">
						<div class="picContent"><img v-lazy="gitem.pic" /></div>
						<div class="item-text">
							<p class="item-title">{{ gitem.title }}</p>
							<div class="item-price">
								<p class="item-introduce">{{ gitem.introduce }}</p>
								<p class="item-price-text">
									<span>
										券后价
										<span>￥</span>
									</span>
									{{ gitem.price }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-else>loading....</div>
	</div>
</template>

<script>
import { Swipe, SwipeItem, Lazyload } from 'vant';

export default {
	data() {
		return {
			moduleList: []
		};
	},
	components: {
		Swipe,
		SwipeItem,
		Lazyload
	},
	created() {
		var params = this.$route.query;
		this.loadData(params);

	},
	methods: {
		clickToGo(e) {
			var params = this.$Helper.obj2Url(e);
 
		},
		clickToGoItems(item) {
			var goodsid = item.goodsId;
			suni.navigateTo({
				url: '/pages/detail/goodsinfo?itemid=' + goodsid
			});
		},
		loadData(params) {
			this.$Request.post('demo/h5view', params).then(res => {
				if (res.status == 200) {
					suni.getCurrentWebview().then(webview => {
						console.log(JSON.stringify(webview));
						console.log(webview.getURL());
					});
					var data = res.data,
						mdata = data.moduleList;
					mdata.forEach((item, index) => {
						mdata[index].content = JSON.parse(mdata[index].content || null);
					});
					this.moduleList = mdata;
				} else {
					suni.showToast({
						title: 'H5不存在'
					});
				}
			});
		}
	}
};
</script>

<style>
* {
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
}
.html5-container {
	background-color: #fff;
	overflow: hidden;
}
.html5-container img {
	vertical-align: middle;
}
.share-btn {
	position: absolute;
	top: 0.2rem;
	right: 0.2rem;
	z-index: 10;
	height: 0.8rem;
	width: 0.8rem;
	/* 	background: url('../../assets/images/html5/icon_share.png') no-repeat; */
	-webkit-background-size: contain;
	background-size: contain;
}
.swipe-content {
	font-size: 0;
}
.swipe-content .van-swipe-item {
	font-size: 0;
}
.swipe-content img {
	width: 100%;
}
.subfield-content {
	overflow: hidden;
}
.subfield-content img {
	width: 100%;
	display: block;
}
.subfield-content .field-item {
	width: 50%;
	float: left;
}
.subfield-content .field-1 {
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
}
.subfield-content .field-1 .field-item {
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	-moz-box-flex: 1;
	-ms-flex: 1;
	flex: 1;
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
}
.subfield-content .field-1 .field-item img {
	height: 100%;
}
.subfield-content .field-1-2,
.subfield-content .field-1-2-1,
.subfield-content .field-1-1-2 {
	overflow: hidden;
	margin-bottom: -1px;
}
.subfield-content .field-1-2-1 .field-item {
	width: 33.3333%;
}
.subfield-content .field-1-2-1 .field-item-3 {
	width: 66.66666%;
}
.subfield-content .field-1-1-2 .field-item {
	width: 33.3333%;
}
.subfield-content .field-1-1-2 .field-item-1 {
	width: 66.66666%;
}
.style-list {
	font-size: 14px;
	overflow-x: scroll;
	width: auto;
}
.style-list .style-item {
	background-color: #fff;
	cursor: pointer;
}
.style-list .style-item .corner-tag {
	z-index: 2;
}
.style-list .style-item .item-title {
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-moz-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
	-webkit-box-align: center;
	-webkit-align-items: center;
	-moz-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	position: relative;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
}
.style-list .style-item .item-introduce {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.style-list .style-item .picContent {
	position: relative;
}
.style-list .style-item .picContent .putawayStatus {
	background-color: rgba(0, 0, 0, 0.5);
	color: #fff;
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-moz-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
	-webkit-box-align: center;
	-webkit-align-items: center;
	-moz-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	width: 60%;
	height: 60%;
	border-radius: 50%;
	position: absolute;
	left: 50%;
	top: 50%;
	-webkit-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	z-index: 3;
}
.style-list-1 {
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-align-content: space-between;
	-ms-flex-line-pack: justify;
	align-content: space-between;
	overflow: hidden;
}
.style-list-1 .style-item {
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	position: relative;
	-webkit-box-flex: 0;
	-webkit-flex: 0 0 98%;
	-moz-box-flex: 0;
	-ms-flex: 0 0 98%;
	flex: 0 0 98%;
	border: 1px solid #eee;
	height: 5rem;
	background-repeat: no-repeat;
	-webkit-background-size: contain;
	background-size: contain;
	background-position-y: bottom;
	margin: 0.1rem 0 0.1rem 0.1rem;
}
.style-list-1 .style-item {
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	height: 2.8rem;
	padding: 0.1rem 0;
}
.style-list-1 .style-item img {
	width: 2.6rem;
	height: 2.6rem;
}
.style-list-1 .style-item .item-box {
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	-moz-box-flex: 1;
	-ms-flex: 1;
	flex: 1;
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-moz-box-orient: vertical;
	-moz-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	padding-left: 0.2rem;
	padding-right: 0.2rem;
}
.style-list-1 .style-item .item-box .item-title {
	font-size: 14px;
	height: 0.8rem;
	line-height: 0.4rem;
	-webkit-line-clamp: 2;
	-webkit-box-align: start;
	-webkit-align-items: start;
	-moz-box-align: start;
	-ms-flex-align: start;
	align-items: start;
}
.style-list-1 .style-item .item-box .item-introduce {
	margin-top: 0.05rem;
	font-size: 12px;
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	-moz-box-flex: 1;
	-ms-flex: 1;
	flex: 1;
	color: #f25e5e;
}
.style-list-1 .style-item .item-box .item-price {
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
}
.style-list-1 .style-item .item-box .item-price .item-price-text {
	font-size: 12px;
	color: #f04646;
	font-weight: 600;
}
.style-list-1 .style-item .item-box .item-price .item-price-text i {
	font-style: normal;
	font-size: 12px;
}
.style-list-1 .style-item .item-box .item-price .item-price-text span {
	font-size: 0.5rem;
}
.style-list-1 .style-item .item-box .item-price .item-org-price-text {
	color: #b8b9b8;
}
.style-list-1 .style-item .item-box .item-price .shopping-cart {
	background-repeat: no-repeat;
	-webkit-background-size: contain;
	background-size: contain;
}
.style-list-1 .style-1-1 .item-box .item-price {
	-webkit-box-pack: justify;
	-webkit-justify-content: space-between;
	-moz-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
}
.style-list-1 .style-1-1 .item-box .shopping-cart {
	-webkit-align-self: flex-end;
	-ms-flex-item-align: end;
	align-self: flex-end;
	display: block;
	width: 0.7rem;
	height: 0.7rem;
	/* 	background-image: url(../../assets/images/html5/gouwu@2x.png); */
}
.style-list-1 .style-1-2 .item-box .item-introduce span {
	display: inline-block;
	padding: 0 7px;
	padding-right: 10px;
	line-height: 0.38rem;
	border-radius: 0 0.38rem 0.38rem 0;
	color: #fff;
	background-color: #2b8d32;
}
.style-list-1 .style-1-2 .item-box .item-price {
	-webkit-box-pack: justify;
	-webkit-justify-content: space-between;
	-moz-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
}
.style-list-1 .style-1-2 .item-box .item-price .item-price-text {
	color: #2b8d32;
}
.style-list-1 .style-1-2 .item-box .item-price .item-price-text span {
	color: #000;
}
.style-list-1 .style-1-2 .item-box .item-price .shopping-cart {
	-webkit-align-self: flex-end;
	-ms-flex-item-align: end;
	align-self: flex-end;
	display: block;
	width: 0.6rem;
	height: 0.6rem;
	/* 	background-image: url(../../assets/images/html5/gouwu3@2x.png); */
}
.style-list-1 .style-1-3 .item-box .item-introduce span {
	display: inline-block;
	padding: 0 7px;
	line-height: 0.38rem;
	color: #bb51ff;
	background-color: #f5eff8;
}
.style-list-1 .style-1-3 .item-box .item-price {
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-moz-box-orient: vertical;
	-moz-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
}
.style-list-1 .style-1-3 .item-box .item-price .item-price-text {
	color: #bb51ff;
}
.style-list-1 .style-1-3 .item-box .item-price .item-price-text span {
	color: #000;
}
.style-list-1 .style-1-3 .item-box .item-price .item-price-text,
.style-list-1 .style-1-3 .item-box .item-price .item-org-price-text {
	display: inline-block;
}
.style-list-1 .style-1-3 .item-box .item-price .item-org-price-text {
	margin-left: 0.2rem;
}
.style-list-1 .style-1-3 .item-box .item-price .shopping-cart {
	margin-top: 0.1rem;
	font-size: 12px;
	text-align: center;
	color: #fff;
	line-height: 0.4rem;
	border-radius: 0.05rem;
	background-color: #bb51ff;
}
.style-list-1 .style-1-4 .item-box .item-introduce span {
	display: inline-block;
	padding: 0 7px;
	line-height: 0.38rem;
	color: #bb51ff;
	border-radius: 0.35rem;
	border: 1px solid #bb51ff;
}
.style-list-1 .style-1-4 .item-box .item-introduce span.item-quan {
	margin-top: 0.1rem;
	color: #f04646;
	border-color: #f04646;
}
.style-list-1 .style-1-4 .item-box .item-price .item-price-flex {
	width: 100%;
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: horizontal;
	-webkit-box-direction: reverse;
	-webkit-flex-direction: row-reverse;
	-moz-box-orient: horizontal;
	-moz-box-direction: reverse;
	-ms-flex-direction: row-reverse;
	flex-direction: row-reverse;
	-webkit-box-pack: justify;
	-webkit-justify-content: space-between;
	-moz-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
}
.style-list-1 .style-1-4 .item-box .item-price .item-price-flex .item-price-text {
	font-size: 14px;
}
.style-list-1 .style-1-4 .item-box .item-price .item-price-flex .item-org-price-text {
	font-size: 12px;
	-webkit-align-self: flex-end;
	-ms-flex-item-align: end;
	align-self: flex-end;
}
.style-list-2,
.style-list-3,
.style-list-4 {
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-align-content: space-between;
	-ms-flex-line-pack: justify;
	align-content: space-between;
	overflow: hidden;
}
.style-list-2 .style-item,
.style-list-3 .style-item,
.style-list-4 .style-item {
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	position: relative;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-moz-box-orient: vertical;
	-moz-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	-webkit-box-flex: 0;
	-webkit-flex: 0 0 48%;
	-moz-box-flex: 0;
	-ms-flex: 0 0 48%;
	flex: 0 0 48%;
	border: 1px solid #eee;
	background-repeat: no-repeat;
	-webkit-background-size: contain;
	background-size: contain;
	background-position-y: bottom;
	margin: 0.1rem 0 0.1rem 0.1rem;
}
.style-list-2 .style-item:nth-child(1),
.style-list-3 .style-item:nth-child(1),
.style-list-4 .style-item:nth-child(1) {
	margin-left: 1.5%;
}
.style-list-2 .style-item img,
.style-list-3 .style-item img,
.style-list-4 .style-item img {
	width: 100%;
}
.style-list-2 .style-item {
	/*    height: 270px; */
}
.style-list-2 .style-item .corner-tag {
	position: absolute;
	top: 0;
	width: 1rem;
	height: 1rem;
	font-size: 12px;
}
.style-list-2 .style-item .item-text {
	margin-top: 8px;
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-moz-box-orient: vertical;
	-moz-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	-moz-box-flex: 1;
	-ms-flex: 1;
	flex: 1;
	-webkit-box-pack: justify;
	-webkit-justify-content: space-between;
	-moz-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
}
.style-list-2 .style-item .item-text .item-title {
	height: 0.8rem;
	line-height: 0.4rem;
	-webkit-line-clamp: 2;
	margin-bottom: 10px;
}
.style-list-2 .style-item .item-text .item-price {
	height: 0.9rem;
	color: #fff;
}
.style-list-2 .style-item .item-text .item-price .item-price-text {
	font-size: 15px;
	font-weight: 600;
}
.style-list-2 .style-item .item-text .item-price .item-price-text span {
	font-size: 12px;
	font-weight: normal;
}
.style-list-2 .style-2-1.style-item,
.style-list-2 .style-2-4.style-item {
	background-image: url('../../assets/module/html5/coupon-price11.png');
}
.style-list-2 .style-2-1 .item-price,
.style-list-2 .style-2-4 .item-price {
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: end;
	-webkit-align-items: flex-end;
	-moz-box-align: end;
	-ms-flex-align: end;
	align-items: flex-end;
}
.style-list-2 .style-2-1 .item-price .item-quan-text,
.style-list-2 .style-2-4 .item-price .item-quan-text {
	font-size: 12px;
	-webkit-writing-mode: vertical-rl;
	-ms-writing-mode: tb-rl;
	writing-mode: vertical-rl;
}
.style-list-2 .style-2-1 .item-price .item-quan-value,
.style-list-2 .style-2-4 .item-price .item-quan-value {
	padding-bottom: 0.1rem;
	font-size: 0.4rem;
}
.style-list-2 .style-2-1 .item-price .item-quan-value span,
.style-list-2 .style-2-4 .item-price .item-quan-value span {
	font-size: 12px;
}
.style-list-2 .style-2-1 .item-price .item-price-text,
.style-list-2 .style-2-4 .item-price .item-price-text {
	padding-bottom: 0.1rem;
	padding-left: 0.4rem;
}
.style-list-2 .style-2-1 .item-price .item-price-text span,
.style-list-2 .style-2-4 .item-price .item-price-text span {
	font-size: 12px;
}
.style-list-2 .style-2-2 .corner-tag {
	left: 0;
}
.style-list-2 .style-2-2.style-item,
.style-list-2 .style-2-3.style-item {
	/* 	background-image: url('../../assets/images/html5/22.png'); */
}
.style-list-2 .style-2-2 .corner-tag,
.style-list-2 .style-2-3 .corner-tag {
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	width: 0.9rem;
	-webkit-box-orient: vertical !important;
	-webkit-box-direction: normal !important;
	-webkit-flex-direction: column !important;
	-moz-box-orient: vertical !important;
	-moz-box-direction: normal !important;
	-ms-flex-direction: column !important;
	flex-direction: column !important;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-moz-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
	text-align: center;
	height: 0.8rem;
	-webkit-flex-direction: row;
	-ms-flex-direction: row;
	flex-direction: row;
	background-color: #ffd83c;
	border-radius: 0 0 0.4rem 0.4rem;
}
.style-list-2 .style-2-2 .item-price,
.style-list-2 .style-2-3 .item-price {
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: end;
	-webkit-align-items: flex-end;
	-moz-box-align: end;
	-ms-flex-align: end;
	align-items: flex-end;
	padding-bottom: 0.15rem;
	font-size: 11px;
}
.style-list-2 .style-2-2 .item-price .item-introduce,
.style-list-2 .style-2-3 .item-price .item-introduce {
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	-moz-box-flex: 1;
	-ms-flex: 1;
	flex: 1;
	text-align: center;
}
.style-list-2 .style-2-2 .item-price .item-price-text,
.style-list-2 .style-2-3 .item-price .item-price-text {
	-webkit-align-self: flex-end;
	-ms-flex-item-align: end;
	align-self: flex-end;
	width: 1.4rem;
	font-size: 0.3rem;
	text-align: center;
}
.style-list-2 .style-2-2 .item-price .item-price-text span,
.style-list-2 .style-2-3 .item-price .item-price-text span {
	font-size: 12px;
}
.style-list-2 .style-2-3.style-item {
	background-image: url('../../assets/module/html5/coupon-price.png');
}
.style-list-2 .style-2-3.style-item .corner-tag {
	width: 0.9rem;
	-webkit-box-orient: vertical !important;
	-webkit-box-direction: normal !important;
	-webkit-flex-direction: column !important;
	-moz-box-orient: vertical !important;
	-moz-box-direction: normal !important;
	-ms-flex-direction: column !important;
	flex-direction: column !important;
	text-align: center;
	height: 0.9rem;
	-webkit-flex-direction: row;
	-ms-flex-direction: row;
	flex-direction: row;
	background: -webkit-gradient(linear, left top, left bottom, from(#dc2cfb), to(#a429fc));
	background: -webkit-linear-gradient(top, #dc2cfb, #a429fc);
	background: -o-linear-gradient(top, #dc2cfb, #a429fc);
	background: linear-gradient(to bottom, #dc2cfb, #a429fc);
	right: 0 !important;
	border-radius: 50%;
	color: #fff;
}
.style-list-2 .style-2-3 .item-price {
	padding-bottom: 0;
}
.style-list-2 .style-2-3 .item-price .item-introduce {
	padding-bottom: 0.2rem;
	text-align: left;
	padding-left: 10px;
}
.style-list-2 .style-2-3 .item-price .item-price-text {
	font-size: 0.26rem;
}
.style-list-2 .style-2-4.style-item {
	/* 	background-image: url('../../assets/images/html5/44.png'); */
}
.style-list-2 .style-2-4 .item-price .item-quan-value {
	padding-left: 0.1rem;
}
.style-list-2 .style-2-4 .item-price .item-price-text {
	padding-left: 0.5rem;
}
.style-list-3 .style-item {
	-webkit-box-flex: 0;
	-webkit-flex: 0 0 31.5%;
	-moz-box-flex: 0;
	-ms-flex: 0 0 31.5%;
	flex: 0 0 31.5%;
	position: relative;
}
.style-list-3 .style-item .corner-tag {
	line-height: 12px;
	position: absolute;
	color: #fff;
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-moz-box-orient: vertical;
	-moz-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-moz-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
	font-size: 12px;
}
.style-list-3 .style-item .corner-tag i {
	font-style: normal;
}
.style-list-3 .style-item .item-text {
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	-moz-box-flex: 1;
	-ms-flex: 1;
	flex: 1;
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-moz-box-orient: vertical;
	-moz-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	text-align: center;
	font-size: 12px;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-moz-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
}
.style-list-3 .style-item .item-text .item-title {
	height: 0.3rem;
	line-height: 0.3rem;
	-webkit-line-clamp: 1;
}
.style-list-3 .style-item .item-text .item-introduce {
	height: 0.3rem;
	line-height: 0.3rem;
}
.style-list-3 .style-item .item-text .item-price {
	padding-top: 0.2rem;
}
.style-list-3 .style-item .item-text .item-price i {
	font-style: normal;
}
.style-list-3 .style-item .item-text .item-price b {
	font-size: 14px;
}
.style-list-3 .style-3-1.style-item .corner-tag {
	right: 0;
	top: 0;
	width: 0.9rem;
	height: 0.9rem;
	border-radius: 50%;
	background-color: #fd5463;
	text-align: center;
}
.style-list-3 .style-3-1.style-item .corner-tag span {
	-webkit-box-ordinal-group: 3;
	-webkit-order: 2;
	-moz-box-ordinal-group: 3;
	-ms-flex-order: 2;
	order: 2;
}
.style-list-3 .style-3-1.style-item .corner-tag b {
	-webkit-box-ordinal-group: 2;
	-webkit-order: 1;
	-moz-box-ordinal-group: 2;
	-ms-flex-order: 1;
	order: 1;
}
.style-list-3 .style-3-1.style-item .item-text .item-introduce {
	color: #ff4dba;
}
.style-list-3 .style-3-1.style-item .item-text .item-price {
	color: #fd666d;
}
.style-list-3 .style-3-1.style-item .item-text .item-price span {
	width: 40px;
	height: 10px;
	display: inline-block;
}
.style-list-3 .style-3-1.style-item .item-text .item-price span img {
	width: 40px;
	vertical-align: middle;
	height: 10px;
}
.style-list-3 .style-3-1.style-item .item-text .item-price b {
	font-weight: 600;
	color: #fc1529;
}
.style-list-3 .style-3-2.style-item .corner-tag {
	width: 1.3rem;
	line-height: 0.4rem;
	-webkit-box-orient: horizontal;
	-webkit-box-direction: normal;
	-webkit-flex-direction: row;
	-moz-box-orient: horizontal;
	-moz-box-direction: normal;
	-ms-flex-direction: row;
	flex-direction: row;
	background-color: #ff9600;
	right: 0;
	border-radius: 0.4rem 0 0 0.4rem;
}
.style-list-3 .style-3-2.style-item .item-text .item-title {
	-webkit-box-ordinal-group: 3;
	-webkit-order: 2;
	-moz-box-ordinal-group: 3;
	-ms-flex-order: 2;
	order: 2;
	color: #262626;
}
.style-list-3 .style-3-2.style-item .item-text .item-introduce {
	-webkit-box-ordinal-group: 2;
	-webkit-order: 1;
	-moz-box-ordinal-group: 2;
	-ms-flex-order: 1;
	order: 1;
	color: #bb51ff;
}
.style-list-3 .style-3-2.style-item .item-text .item-price {
	-webkit-box-ordinal-group: 4;
	-webkit-order: 3;
	-moz-box-ordinal-group: 4;
	-ms-flex-order: 3;
	order: 3;
}
.style-list-3 .style-3-2.style-item .item-text .item-price i {
	border: 1px solid #bb51ff;
	border-radius: 0.05rem;
	color: #bb51ff;
	padding: 0 0.1rem;
}
.style-list-3 .style-3-3.style-item .corner-tag {
	width: 0.9rem;
	-webkit-box-orient: vertical !important;
	-webkit-box-direction: normal !important;
	-webkit-flex-direction: column !important;
	-moz-box-orient: vertical !important;
	-moz-box-direction: normal !important;
	-ms-flex-direction: column !important;
	flex-direction: column !important;
	text-align: center;
	height: 0.8rem;
	-webkit-flex-direction: row;
	-ms-flex-direction: row;
	flex-direction: row;
	background-color: #fc1529;
	right: 0;
	border-radius: 0 0 0.3rem 0.3rem;
}
.style-list-3 .style-3-3.style-item .item-text .item-title {
	-webkit-box-ordinal-group: 2;
	-webkit-order: 1;
	-moz-box-ordinal-group: 2;
	-ms-flex-order: 1;
	order: 1;
}
.style-list-3 .style-3-3.style-item .item-text .item-introduce {
	-webkit-box-ordinal-group: 4;
	-webkit-order: 3;
	-moz-box-ordinal-group: 4;
	-ms-flex-order: 3;
	order: 3;
	width: 80%;
	margin: 0 auto;
	background: -webkit-gradient(linear, left top, right top, from(#ff3133), to(#ff019b));
	background: -webkit-linear-gradient(left, #ff3133, #ff019b);
	background: -o-linear-gradient(left, #ff3133, #ff019b);
	background: linear-gradient(to right, #ff3133, #ff019b);
	color: #fff;
	height: 0.4rem;
	line-height: 0.4rem;
	border-radius: 0.4rem;
}
.style-list-3 .style-3-3.style-item .item-text .item-price {
	padding: 0.1rem;
	-webkit-box-ordinal-group: 3;
	-webkit-order: 2;
	-moz-box-ordinal-group: 3;
	-ms-flex-order: 2;
	order: 2;
	color: #fc1529;
}
.style-list-3 .style-3-4.style-item .corner-tag {
	width: 1rem;
	-webkit-box-orient: vertical !important;
	-webkit-box-direction: normal !important;
	-webkit-flex-direction: column !important;
	-moz-box-orient: vertical !important;
	-moz-box-direction: normal !important;
	-ms-flex-direction: column !important;
	flex-direction: column !important;
	text-align: center;
	height: 1rem;
	-webkit-flex-direction: row;
	-ms-flex-direction: row;
	flex-direction: row;
	color: #830abc;
	left: 0;
	top: 1.25rem;
	border-radius: 50%;
	/* 	background: url('../../assets/images/html5/12@2x.png') no-repeat; */
	-webkit-background-size: contain;
	background-size: contain;
}
.style-list-3 .style-3-4.style-item .item-text {
	color: #fff;
	background: -webkit-gradient(linear, left top, right bottom, from(#ff009d), to(#830abc));
	background: -webkit-linear-gradient(top left, #ff009d, #830abc);
	background: -o-linear-gradient(top left, #ff009d, #830abc);
	background: linear-gradient(to bottom right, #ff009d, #830abc);
}
.style-list-3 .style-3-4.style-item .item-text .item-title {
	-webkit-box-ordinal-group: 4;
	-webkit-order: 3;
	-moz-box-ordinal-group: 4;
	-ms-flex-order: 3;
	order: 3;
}
.style-list-3 .style-3-4.style-item .item-text .item-introduce {
	-webkit-box-ordinal-group: 2;
	-webkit-order: 1;
	-moz-box-ordinal-group: 2;
	-ms-flex-order: 1;
	order: 1;
	color: #830abc;
	background-color: #fff;
	width: 80%;
	margin: 0 auto;
	height: 0.4rem;
	line-height: 0.4rem;
	border-radius: 0.4rem;
}
.style-list-3 .style-3-4.style-item .item-text .item-price {
	padding: 0.1rem;
	-webkit-box-ordinal-group: 3;
	-webkit-order: 2;
	-moz-box-ordinal-group: 3;
	-ms-flex-order: 2;
	order: 2;
}
.style-list-3 .style-3-5.style-item .corner-tag {
	right: 0;
	top: 0;
	width: 0.9rem;
	height: 0.9rem;
	border-radius: 50%;
	background-color: #ffd83d;
	color: #000;
	text-align: center;
}
.style-list-3 .style-3-5.style-item .corner-tag span {
	-webkit-box-ordinal-group: 2;
	-webkit-order: 1;
	-moz-box-ordinal-group: 2;
	-ms-flex-order: 1;
	order: 1;
}
.style-list-3 .style-3-5.style-item .corner-tag b {
	-webkit-box-ordinal-group: 3;
	-webkit-order: 2;
	-moz-box-ordinal-group: 3;
	-ms-flex-order: 2;
	order: 2;
}
.style-list-3 .style-3-5.style-item .item-text {
	color: #fff;
	background: -webkit-gradient(linear, left top, right top, from(#ff25c2), to(#ff38a8));
	background: -webkit-linear-gradient(left, #ff25c2, #ff38a8);
	background: -o-linear-gradient(left, #ff25c2, #ff38a8);
	background: linear-gradient(to right, #ff25c2, #ff38a8);
}
.style-list-3 .style-3-5.style-item .item-text .item-title {
	-webkit-box-ordinal-group: 3;
	-webkit-order: 2;
	-moz-box-ordinal-group: 3;
	-ms-flex-order: 2;
	order: 2;
	font-weight: 600;
}
.style-list-3 .style-3-5.style-item .item-text .item-introduce {
	-webkit-box-ordinal-group: 2;
	-webkit-order: 1;
	-moz-box-ordinal-group: 2;
	-ms-flex-order: 1;
	order: 1;
	color: #ff25c2;
	background-color: #fff;
	width: 80%;
	margin: 0 auto;
	height: 0.4rem;
	line-height: 0.4rem;
	border-radius: 0.4rem;
	margin-top: -0.4rem;
	margin-bottom: 0.3rem;
	z-index: 4;
}
.style-list-3 .style-3-5.style-item .item-text .item-price {
	padding: 0.1rem;
	-webkit-box-ordinal-group: 4;
	-webkit-order: 3;
	-moz-box-ordinal-group: 4;
	-ms-flex-order: 3;
	order: 3;
}
.style-list-4 .style-item {
	-webkit-box-flex: 0;
	-webkit-flex: 0 0 23.4%;
	-moz-box-flex: 0;
	-ms-flex: 0 0 23.4%;
	flex: 0 0 23.4%;
	height: 3.2rem;
	position: relative;
}
.style-list-4 .style-item .item-text {
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	-moz-box-flex: 1;
	-ms-flex: 1;
	flex: 1;
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-moz-box-orient: vertical;
	-moz-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	text-align: center;
	font-size: 12px;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-moz-box-pack: center;
	-ms-flex-pack: center;
	justify-content: center;
}
.style-list-4 .style-item .item-text .item-title {
	height: 0.3rem;
	line-height: 0.3rem;
	-webkit-line-clamp: 1;
}
.style-list-4 .style-item .item-text .item-introduce {
	height: 0.4rem;
	line-height: 0.4rem;
	margin-top: 0.1rem;
	width: 1.2rem !important;
	z-index: 3;
	margin: 0 auto;
}
.style-list-4 .style-item .item-text .item-price {
	margin-top: 0.1rem;
}
.style-list-4 .style-item .item-text .item-price i {
	font-style: normal;
}
.style-list-4 .style-item .item-text .item-price b {
	font-size: 12px;
}
.style-list-4 .style-4-1 .item-text .item-title {
	color: #cacaca;
}
.style-list-4 .style-4-1 .item-text .item-price {
	margin-top: 0.1rem;
	display: -webkit-box;
	display: -webkit-flex;
	display: -moz-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-moz-box-orient: vertical;
	-moz-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
}
.style-list-4 .style-4-1 .item-text .item-price i {
	border: 1px solid #bb51ff;
	border-radius: 0.05rem;
	color: #bb51ff;
	width: 60%;
	margin: 0 auto;
}
.style-list-4 .style-4-1 .item-text .item-price b {
	margin-top: 0.1rem;
}
.style-list-4 .style-4-2 .item-text .item-introduce {
	color: #fff;
	background: -webkit-gradient(linear, left top, right top, from(#ff3133), to(#ff019b));
	background: -webkit-linear-gradient(left, #ff3133, #ff019b);
	background: -o-linear-gradient(left, #ff3133, #ff019b);
	background: linear-gradient(to right, #ff3133, #ff019b);
	line-height: 0.4rem;
	border-radius: 0.4rem;
}
.style-list-4 .style-4-2 .item-text .item-price {
	color: #fc1529;
}
.style-list-4 .style-4-3 .item-text {
	color: #fff;
	background: -webkit-gradient(linear, left top, right bottom, from(#ff009d), to(#830abc));
	background: -webkit-linear-gradient(top left, #ff009d, #830abc);
	background: -o-linear-gradient(top left, #ff009d, #830abc);
	background: linear-gradient(to bottom right, #ff009d, #830abc);
}
.style-list-4 .style-4-3 .item-text .item-title {
	margin-top: 0.05rem;
	-webkit-box-ordinal-group: 3;
	-webkit-order: 2;
	-moz-box-ordinal-group: 3;
	-ms-flex-order: 2;
	order: 2;
}
.style-list-4 .style-4-3 .item-text .item-introduce {
	-webkit-box-ordinal-group: 2;
	-webkit-order: 1;
	-moz-box-ordinal-group: 2;
	-ms-flex-order: 1;
	order: 1;
	margin-top: 0.1rem;
	background-color: #fff;
	color: #830abc;
	line-height: 0.4rem;
	border-radius: 0.4rem;
	order: 1;
}
.style-list-4 .style-4-3 .item-text .item-price {
	margin-top: 0.05rem;
	-webkit-box-ordinal-group: 4;
	-webkit-order: 3;
	-moz-box-ordinal-group: 4;
	-ms-flex-order: 3;
	order: 3;
}
.style-list-4 .style-4-4 .item-text {
	color: #fff;
	background: -webkit-gradient(linear, left top, right top, from(#ff25c2), to(#ff38a8));
	background: -webkit-linear-gradient(left, #ff25c2, #ff38a8);
	background: -o-linear-gradient(left, #ff25c2, #ff38a8);
	background: linear-gradient(to right, #ff25c2, #ff38a8);
}
.style-list-4 .style-4-4 .item-text .item-title {
	margin-top: 0.05rem;
	-webkit-box-ordinal-group: 4;
	-webkit-order: 3;
	-moz-box-ordinal-group: 4;
	-ms-flex-order: 3;
	order: 3;
}
.style-list-4 .style-4-4 .item-text .item-introduce {
	-webkit-box-ordinal-group: 2;
	-webkit-order: 1;
	-moz-box-ordinal-group: 2;
	-ms-flex-order: 1;
	order: 1;
	background-color: #fff;
	color: #ff25c2;
	line-height: 0.4rem;
	border-radius: 0.4rem;
	margin-top: -0.4rem;
	order: 1;
}
.style-list-4 .style-4-4 .item-text .item-price {
	margin-top: 0.3rem;
	-webkit-box-ordinal-group: 3;
	-webkit-order: 2;
	-moz-box-ordinal-group: 3;
	-ms-flex-order: 2;
	order: 2;
}
.style-list-4 .style-4-5 .item-text .item-title {
	margin-top: 0.05rem;
	-webkit-box-ordinal-group: 2;
	-webkit-order: 1;
	-moz-box-ordinal-group: 2;
	-ms-flex-order: 1;
	order: 1;
}
.style-list-4 .style-4-5 .item-text .item-introduce {
	-webkit-box-ordinal-group: 4;
	-webkit-order: 3;
	-moz-box-ordinal-group: 4;
	-ms-flex-order: 3;
	order: 3;
	background-color: #fff !important;
	color: #830abc;
	line-height: 0.4rem;
	border-radius: 0.4rem;
	z-index: 3;
	position: relative;
}
.style-list-4 .style-4-5 .item-text .item-price {
	-webkit-box-ordinal-group: 3;
	-webkit-order: 2;
	-moz-box-ordinal-group: 3;
	-ms-flex-order: 2;
	order: 2;
	color: #eb4bff;
}
.style-list-4 .style-4-5 .item-text .style-4-4-bg {
	position: absolute;
	width: 100%;
	height: 0.3rem;
	background: -webkit-gradient(linear, left top, right bottom, from(#830abc), to(#e546ff));
	background: -webkit-linear-gradient(top left, #830abc, #e546ff);
	background: -o-linear-gradient(top left, #830abc, #e546ff);
	background: linear-gradient(to bottom right, #830abc, #e546ff);
	border-radius: 10px 10px 0 0;
	left: 0;
	bottom: 0;
	z-index: 2;
}
.can-wrap {
	-webkit-flex-wrap: wrap;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	overflow-x: hidden;
}
.can-scroll {
	-webkit-flex-wrap: nowrap;
	-ms-flex-wrap: nowrap;
	flex-wrap: nowrap;
	overflow-x: scroll;
}
</style>
